export default __webpack_public_path__ + "static/media/menu_2_cloud_4.dc55e9ea.svg";